// extracted by mini-css-extract-plugin
module.exports = {"pricingWrapper":"DigiCertMarkPricing_pricingWrapper__WJtFL"};